/**
 * The origin a web read goes to (D354 "web reads"), zod-free so the host, the proposal card and the tests all say the same thing.
 */
/**
 * The origin of a web read's address, or undefined when it is not one a web read may use: https (http only for this computer),
 * a host, no sign-in in it. `https://api.example.com:8443/x?y` → `https://api.example.com:8443`.
 */
export function webOrigin(url) {
    let u;
    try {
        u = new URL(url);
    }
    catch {
        return undefined;
    }
    if (!u.hostname || u.username || u.password)
        return undefined;
    const h = u.hostname.toLowerCase().replace(/^\[|\]$/g, "");
    const here = h === "localhost" || h.endsWith(".localhost") || h === "::1" || /^127\.\d+\.\d+\.\d+$/.test(h);
    if (u.protocol === "https:" || (u.protocol === "http:" && here))
        return u.origin;
    return undefined;
}
/** The distinct origins of a list of web reads, in order. */
export const originsOfReads = (reads) => [...new Set((reads ?? []).map((w) => webOrigin(w.url)).filter((o) => !!o))];
/** The host of an origin, for sentences ("api.example.com"). */
export const originHost = (origin) => {
    try {
        return new URL(origin).host;
    }
    catch {
        return origin;
    }
};
//# sourceMappingURL=webOrigin.js.map